import React, { useCallback, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/styles";
import { Button, Badge, Menu, MenuItem, Avatar } from "@material-ui/core";
import { ReactComponent as NotificationIcon } from "../../images/Notification_icon.svg";
import {
  ManagePack,
  Notepad,
  ClientNav,
  Employees,
  InvoiceNav,
  NotificationProfile,
} from "../../images";
import "./notificaton.scss";
import { dateTimeFormatter, getRolePath } from "../../utils/common";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles({
  button: {
    minWidth: "unset",
    "& svg": {
      color: "#0067b8",
      fontSize: "2rem",
    },
  },
  icon: {
    display: "inline-flex",
  },
  badge: {
    right: "2px",
    top: "-10px",
  },
  error: {
    backgroundColor: "#E41F3A",
  },
  disabled: {
    background: "#F0F0F0",
  },
});

const Notification = (props) => {
  const classes = useStyles(props);
  const navigate = useNavigate();
  const {
    disable,
    handleClick,
    badgeText,
    notifications,
    onMenuClick,
    onLoadMore,
    hasMore,
    loadingMore,
  } = props;
  const [anchor, setAnchor] = React.useState(null);
  const listRef = useRef(null);
  const loadingMoreRef = useRef(false);

  useEffect(() => {
    loadingMoreRef.current = Boolean(loadingMore);
  }, [loadingMore]);

  const maybeLoadMore = useCallback(() => {
    if (!hasMore || loadingMoreRef.current) return;
    if (typeof onLoadMore === "function") onLoadMore();
  }, [hasMore, onLoadMore]);

  const handleScroll = useCallback(
    (event) => {
      const el = event.currentTarget;
      if (!el) return;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 48) {
        maybeLoadMore();
      }
    },
    [maybeLoadMore],
  );

  useEffect(() => {
    if (!anchor) return undefined;
    const el = listRef.current;
    if (!el) return undefined;
    if (hasMore && el.scrollHeight <= el.clientHeight + 8) {
      maybeLoadMore();
    }
    return undefined;
  }, [anchor, notifications, hasMore, loadingMore, maybeLoadMore]);

  const showAvatar = (type) => {
    switch (type) {
      case "client":
        return ClientNav;
      case "employee":
        return Employees;
      case "contract":
        return Notepad;
      case "invoice":
        return InvoiceNav;
      case "payment":
        return ManagePack;
      case "message":
      case "messages":
        return Notepad;
      default:
        return NotificationProfile;
    }
  };
  return (
    <div>
      <Button
        disabled={disable}
        className={`${classes.button}`}
        onClick={(e) => {
          e.stopPropagation();
          setAnchor(e.currentTarget);
          if (handleClick) handleClick();
        }}
        classes={{
          disabled: classes.disabled,
        }}
      >
        <NotificationIcon width={28} height={28} />
        {badgeText && (
          <Badge
            badgeContent={badgeText}
            color="error"
            classes={{ badge: classes.badge, colorError: classes.error }}
            overlap="circular"
          />
        )}
      </Button>
      <Menu
        classes={{
          paper: "timesheet-view-modal-notify",
        }}
        anchorEl={anchor}
        keepMounted
        open={Boolean(anchor)}
        onClose={(e) => {
          setAnchor(null);
          e.stopPropagation();
        }}
        getContentAnchorEl={null}
        autoFocus={false}
        disableAutoFocusItem
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        MenuListProps={{ disablePadding: true }}
      >
        <h2 style={{ marginLeft: 20, marginTop: 4 }}>Notifications</h2>
        <div
          className="notify-menu-scroll"
          ref={listRef}
          onScroll={handleScroll}
        >
          {notifications.length > 0 ? (
            notifications.map((option, index) => (
              <MenuItem
                key={option?.notification_id ?? index}
                onClick={(e) => {
                  setAnchor(null);
                  e.stopPropagation();
                  if (onMenuClick) onMenuClick(option);
                }}
                className={`${
                  option?.view_status === "Not Viewed" &&
                  "notify-unread-menuitem"
                } notify-border`}
              >
                <div className="notify-tile">
                  <Avatar
                    alt={option?.notification_type}
                    src={showAvatar(option.notification_type)}
                    className="notify-avatar"
                  />
                  <div className="message-tile">
                    <div className={`notify-message`}>{option.message}</div>
                    <div className={`notify-time`}>
                      {dateTimeFormatter(option.createdAt)}
                    </div>
                  </div>
                </div>
              </MenuItem>
            ))
          ) : (
            <MenuItem>
              <div className="message-tile">
                <div className="notify-message no-notify">
                  {hasMore || loadingMore
                    ? "Loading notifications…"
                    : "No new notification"}
                </div>
              </div>
            </MenuItem>
          )}
          {loadingMore ? (
            <div className="notify-menu-status">Loading more…</div>
          ) : null}
        </div>
        {notifications?.length > 0 ? (
          <div
            className="notify-see-all"
            onClick={() => {
              setAnchor(null);
              navigate(getRolePath("/notifications"));
            }}
          >
            See all
          </div>
        ) : null}
      </Menu>
    </div>
  );
};

export default Notification;
